<template>
  <div class="goodsManageSet">
    <div class="banner">
      <img src="../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <!-- <div class="breadcrumb_icon">
        <i class="iconfont icon-shangpinsku"></i>
      </div>
      <div class="breadcrumb_item">SKU管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">商品管理</div> -->
    </div>

    <div class="main_content">
      <div class="tit">消费规则管理</div>
      <div class="block">
        <h1><span class="mark">*</span>是否允许使用积分抵扣支付</h1>
        <div class="radio_box">
          <van-radio-group
            direction="horizontal"
            v-model="formData.isallowscore"
          >
            <van-radio name="1">是</van-radio>
            <van-radio name="0">否</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="block">
        <h1><span class="mark">*</span>是否限制抵扣额度</h1>
        <div class="radio_box">
          <van-radio-group direction="horizontal" v-model="formData.lslimit">
            <van-radio name="1">限制</van-radio>
            <van-radio name="0">不限制</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="block">
        <h1>
          <span class="mark">*</span>最大抵扣额度（数字输入项，仅支持整数数字）
        </h1>
        <div class="input_box">
          <van-field
            v-model="formData.maxdiscount"
            type="digit"
            placeholder="请输入最大抵扣额度"
          />
        </div>
      </div>
    </div>

    <div class="primary-button" @click="query">保存确认</div>
    <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i>返回
    </div>
  </div>
</template>

<script>
import { encryptstringview } from "../../api/api";
import {
  getConsumptionRule,
  addConsumptionRule,
  editConsumptionRule,
} from "../../api/company";
import { mapState } from "vuex";
export default {
  name: "consumptionRule",
  data() {
    return {
      loading: false,
      id: '',  // 是否已提交数据
      formData: {
        qyguid: "",
        isallowscore: "",
        lslimit: "",
        maxdiscount: "",
      },
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { qyguid } = JSON.parse(res.jsondata);
        this.formData.qyguid = qyguid;
        this.getConsumptionRule();
      } else {
        this.$router.back();
      }
    },

    // 获取消费规则
    getConsumptionRule() {
      let qyguid = this.formData.qyguid;
      getConsumptionRule({ qyguid }).then((res) => {
        this.id = res.id ? res.id : ''
        this.formData.isallowscore = res.isallowscore ? res.isallowscore : 0
        this.formData.lslimit = res.lslimit ? res.lslimit : 0
        this.formData.maxdiscount = res.maxdiscount
      });
    },

    query() {
      let { formData, id } = this;
      if (formData.isallowscore == "") {
        this.$toast("请选择是否允许使用积分抵扣支付");
        return;
      }
      if (formData.lslimit == "") {
        this.$toast("请选择是否限制抵扣额度");
        return;
      }
      if (formData.maxdiscount == "") {
        this.$toast("请输入最大抵扣额度");
        return;
      }
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      if (id != "") {
        editConsumptionRule(formData).then((res) => {
          let data = res;
          if (data.result) {
            setTimeout(() => {
              Toast.clear();
              this.$toast.success(data.message);
            }, 500);
            setTimeout(() => {
              history.back();
            }, 1500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addConsumptionRule(formData).then((res) => {
          let data = res;
          if (data.result) {
            setTimeout(() => {
              Toast.clear();
              this.$toast.success(data.message);
            }, 500);
            setTimeout(() => {
              history.back();
            }, 1500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      }
    },

    handleReturn() {
      history.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      .textarea_box {
        .van-cell {
          padding: 10px 0;
          width: 100%;
          height: 100%;
        }
      }
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .img_box {
        margin: auto;
        margin-top: 40px;
        text-align: center;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
    }
  }
  .van-radio,
  .van-checkbox {
    margin-bottom: 10px;
  }
}
</style>